
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wiki/roles/[slug]",
      function () {
        return require("private-next-pages/wiki/roles/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wiki/roles/[slug]"])
      });
    }
  